
















import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import renewRemind from "./renewalRemind/index.vue";
import renewalRecord from "./renewalRecord/index.vue";
import { mixin } from "@/mixin/tabPageInfoMixin";
import { staffCheckApi } from "@/api/makeUpLessons";
@Component({
  components: {
    renewRemind,
    renewalRecord,
  },
})
export default class extends Mixins(mixin) {
  activeName: string = "renewRemind";
  showRenewalRecord: boolean = false;
  created() {
    staffCheckApi({
      api_path: ["/api/v1/student/course/renew_record_list"],
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.showRenewalRecord = res.data[
          "/api/v1/student/course/renew_record_list"
        ]
          ? true
          : false;
      }
    });
    this.mixinGetPageInfo("renewRecordSearch");
    if (this.$route.query.from === "renewal") {
      this.activeName = "renewalRecord";
    }
  }
  handleClick(t: any) {
    this.mixinSavePageInfo("renewRecordSearch", this.activeName);
  }
}
